import React from 'react';
import { extractVimeoHParam, extractVimeoId } from './utils';

interface VimeoIframeProps {
    link: string;
}

export const VimeoIframe = ({ link }: VimeoIframeProps) => {
    const vimeoId = extractVimeoId(link);
    console.log(vimeoId);
    
    const vimeoH = extractVimeoHParam(link);
    console.log(vimeoH);

    const getPlayerUrl = () => {
        if(link.includes('player.vimeo.com')){
            return link;
        }
        return `https://player.vimeo.com/video/${vimeoId}?h=${vimeoH}`;
    }

    return (
        <div className="vimeo-wrapper">
            <iframe
                title="Vimeo video player"
                src={getPlayerUrl()}
                width="100%"
                height="100%"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                style={{ border: 'none' }}
            />
        </div>
    );
};
